<div class="pt-3" *ngIf="customerNotFound">
  <h2>Customer not found.</h2>
</div>

<div class="pt-3" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3" *ngIf="!customerNotFound && (serverError === null)">

  <div *ngIf="successMessage" class="alert alert-success text-center" role="alert">
    {{ successMessage }}
  </div>

  <div class="rounded-table-wrapper rounded-table-tight table-responsive mb-2">
    <table class="table">

      <thead>
      <tr>
        <th scope="col" colspan="99" class="text-primary"
            style="font-size: 16px; padding-top: 8px; padding-bottom: 8px; line-height: 12px;">
          <button class="btn btn-sm btn-outline-primary float-right"
                  style="font-size: 12px; line-height: 12px;"
                  [disabled]="loadingCustomer"
                  [class.disabled]="loadingCustomer"
                  (click)="openPurchaseMembershipModal()">
            Purchase Membership
          </button>
          <span style="position: relative; top: 4px;">Memberships</span>
        </th>
      </tr>
      <tr>
        <th scope="col" class="text-nowrap">Membership Name</th>
        <th scope="col" class="text-nowrap">Payment Type</th>
        <th scope="col" class="text-nowrap">Length</th>
        <th scope="col"></th>
      </tr>
      </thead>

      <tbody *ngIf="!loadingMemberships">
      <tr *ngFor="let membership of membershipsList.results"
          [class.font-italic]="membership.status === CustomerMembershipStatus.ended">
        <td class="membership-name-cell">
          <span title="Customer Membership #{{ membership.id }}"
                class="d-block">
            {{ membership.name }}
          </span>
          <span *ngIf="membership.rolling_event_type_roster_name"
                class="membership-name-secondary d-block">
            Roster: {{ membership.rolling_event_type_roster_name }}
          </span>
          <span *ngIf="membership.is_pending_staff_approval && (membership.status !== CustomerMembershipStatus.ended)"
                class="membership-name-secondary">
            <span class="text-warning">Pending approval</span>
            (<a href="#"
                (click)="openReviewMembershipPendingStaffApprovalModal(membership.id);$event.preventDefault();">Review</a>)
          </span>
          <ng-container *ngIf="!membership.is_pending_staff_approval">
            <ng-container *ngIf="membership.purchase_type === MembershipPurchaseType.recurring">
              <span *ngIf="membership.status === CustomerMembershipStatus.active"
                    class="text-success membership-name-secondary">
                <ng-container *ngIf="!membership.has_started">
                  Paid, will start on: {{ dateStringFromISO8601(membership.start_date) }}
                </ng-container>
                <ng-container *ngIf="membership.has_started && !(membership.membership_cancel_date || membership.membership_freeze_date)">
                  Active, next bill date: {{ dateStringFromISO8601(membership.end_date) }}
                </ng-container>
                <ng-container *ngIf="membership.has_started && membership.membership_cancel_date">
                  <ng-container *ngIf="membership.membership_cancel_date > membership.end_date">
                    Active, next bill date: {{ dateStringFromISO8601(membership.end_date) }}, will end on: {{ dateStringFromISO8601(membership.membership_cancel_date) }}
                  </ng-container>
                  <ng-container *ngIf="membership.membership_cancel_date <= membership.end_date">
                    Active, will end on: {{ dateStringFromISO8601(membership.membership_cancel_date) }}
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="membership.has_started && !membership.membership_cancel_date && membership.membership_freeze_date">
                  <ng-container *ngIf="membership.membership_freeze_date > membership.end_date">
                    Active, next bill date: {{ dateStringFromISO8601(membership.end_date) }}, will freeze on: {{ dateStringFromISO8601(membership.membership_freeze_date) }}
                  </ng-container>
                  <ng-container *ngIf="membership.membership_freeze_date <= membership.end_date">
                    Active, will freeze on: {{ dateStringFromISO8601(membership.membership_freeze_date) }}
                  </ng-container>
                  <ng-container *ngIf="membership.membership_unfreeze_date !== null">
                    and unfreeze on: {{ dateStringFromISO8601(membership.membership_unfreeze_date) }}
                  </ng-container>
                </ng-container>
              </span>
              <span *ngIf="membership.status === CustomerMembershipStatus.frozen"
                    class="text-secondary membership-name-secondary">
                <ng-container *ngIf="membership.has_freeze_fee">
                  <ng-container *ngIf="membership.membership_unfreeze_date !== null">
                    <ng-container *ngIf="membership.end_date < membership.membership_unfreeze_date">
                      Frozen, next freeze fee date: {{ dateStringFromISO8601(membership.end_date) }}, will unfreeze on: {{ dateStringFromISO8601(membership.membership_unfreeze_date) }}
                    </ng-container>
                    <ng-container *ngIf="membership.end_date >= membership.membership_unfreeze_date">
                      Frozen, will unfreeze on: {{ dateStringFromISO8601(membership.membership_unfreeze_date) }}
                    </ng-container>
                  </ng-container>
                  <ng-container *ngIf="membership.membership_unfreeze_date === null">
                    Frozen, next freeze fee date: {{ dateStringFromISO8601(membership.end_date) }}
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="!membership.has_freeze_fee">
                  <ng-container *ngIf="membership.membership_unfreeze_date !== null">
                    Frozen, will unfreeze on: {{ dateStringFromISO8601(membership.membership_unfreeze_date) }}
                  </ng-container>
                  <ng-container *ngIf="membership.membership_unfreeze_date === null">
                    Frozen
                  </ng-container>
                </ng-container>
              </span>
              <span *ngIf="membership.status === CustomerMembershipStatus.initialPaymentProcessing"
                    class="text-warning membership-name-secondary">
                Initial payment processing
              </span>
              <!--
                PRO-1460. This chain has no fallback, so a status without its
                own branch renders nothing at all - which reads as missing data
                rather than as a state, and would leave a paid-but-inactive
                membership looking identical to a live one on the one screen
                staff check.
              -->
              <span *ngIf="membership.status === CustomerMembershipStatus.awaitingPaymentMethod"
                    class="text-warning membership-name-secondary">
                Paid, not active &mdash; awaiting a payment method
              </span>
              <span *ngIf="membership.status === CustomerMembershipStatus.renewalPaymentPending"
                    class="text-warning membership-name-secondary">
                Renewal payment pending, last bill attempt: {{ dateStringFromISO8601(membership.end_date) }}
              </span>
              <span *ngIf="membership.status === CustomerMembershipStatus.renewalPaymentProcessing"
                    class="text-warning membership-name-secondary">
                Renewal payment processing, billing started: {{ dateStringFromISO8601(membership.end_date) }}
              </span>
              <span *ngIf="membership.status === CustomerMembershipStatus.renewalPaymentFailed"
                    class="text-danger membership-name-secondary">
                Renewal payment failed: {{ dateStringFromISO8601(membership.end_date) }}
              </span>
              <span *ngIf="membership.status === CustomerMembershipStatus.freezePaymentPending"
                    class="text-warning membership-name-secondary">
                Freeze payment pending, last bill attempt: {{ dateStringFromISO8601(membership.end_date) }}
              </span>
              <span *ngIf="membership.status === CustomerMembershipStatus.freezePaymentProcessing"
                    class="text-warning membership-name-secondary">
                Freeze payment processing, billing started: {{ dateStringFromISO8601(membership.end_date) }}
              </span>
              <span *ngIf="membership.status === CustomerMembershipStatus.freezePaymentFailed"
                    class="text-danger membership-name-secondary">
                Freeze payment failed: {{ dateStringFromISO8601(membership.end_date) }}
              </span>
              <span *ngIf="membership.status === CustomerMembershipStatus.ended"
                    class="text-secondary membership-name-secondary">
                Ended on {{ dateStringFromISO8601(membership.end_date) }}
              </span>
              <span *ngIf="membership.status === CustomerMembershipStatus.deniedStaffApproval"
                    class="text-secondary membership-name-secondary">
                Denied approval
              </span>
              <!--
                Fallback, so this chain can never again render a row with no
                status at all. Every status above has bespoke wording; anything
                without one falls back to the shared label rather than
                vanishing, which is how a paid-but-inactive membership came to
                look identical to a live one (PRO-1460). Reaching this is a
                sign the status wants its own branch, not that the fallback is
                doing its job.
              -->
              <span *ngIf="!recurringStatusesWithOwnLabel.includes(membership.status)"
                    [class]="getMembershipStatusColorClass(membership.status) + ' membership-name-secondary'">
                {{ getCustomerMembershipStatusDisplay(membership.status) }}
              </span>
            </ng-container>
            <ng-container *ngIf="membership.purchase_type === MembershipPurchaseType.prepaid">
              <span *ngIf="membership.status === CustomerMembershipStatus.active"
                    class="text-success membership-name-secondary">
                <ng-container *ngIf="membership.has_started">
                  Active until the end of {{ dateStringFromISO8601(membership.last_active_date) }}
                </ng-container>
                <ng-container *ngIf="!membership.has_started">
                  Paid, will start on: {{ dateStringFromISO8601(membership.start_date) }}
                </ng-container>
              </span>
              <span *ngIf="membership.status === CustomerMembershipStatus.ended"
                    class="text-secondary membership-name-secondary">
                Ended on {{ dateStringFromISO8601(membership.end_date) }}
              </span>
              <span *ngIf="membership.status === CustomerMembershipStatus.frozen"
                    class="text-secondary membership-name-secondary">
                Frozen, {{ membership.days_remaining }} days remaining
              </span>
              <span *ngIf="membership.status === CustomerMembershipStatus.deniedStaffApproval"
                    class="text-secondary membership-name-secondary">
                Denied approval
              </span>
            </ng-container>
            <ng-container *ngIf="membership.purchase_type === MembershipPurchaseType.benefit">
              <span *ngIf="membership.status === CustomerMembershipStatus.active"
                    class="text-success membership-name-secondary">
                Granted by {{ membership.event_granting_benefit_name }}<br>
                <ng-container *ngIf="membership.has_started">
                  Active until the end of {{ dateStringFromISO8601(membership.last_active_date) }}
                </ng-container>
                <ng-container *ngIf="!membership.has_started">
                  Will start on: {{ dateStringFromISO8601(membership.start_date) }}
                </ng-container>
              </span>
              <span *ngIf="membership.status === CustomerMembershipStatus.ended"
                    class="text-secondary membership-name-secondary">
                Granted by {{ membership.event_granting_benefit_name }}<br>
                Ended on {{ dateStringFromISO8601(membership.end_date) }}
              </span>
            </ng-container>
          </ng-container>
          <span *ngIf="membership.location_id" class="membership-name-secondary d-block mt-3">
            Location: {{ membership.location_name }}
          </span>
          <!-- Display the owner / members if there are members other than the owner, or if any member is individually frozen -->
          <!-- The members-other-than-owner case can happen with non-group memberships, if the owner purchased the membership for someone else -->
          <ng-container *ngIf="shouldShowMembersList(membership)">
            <ng-container *appVar="getMembershipOwnerMember(membership) as ownerMember">
              <span class="membership-name-secondary d-block mt-3"
                    [class.font-italic]="ownerMember && ownerMember.is_pending_addition">
                <a routerLink="/customers/{{ membership.owner_id }}/memberships-and-passes">
                  {{ membership.owner_first_name }} {{ membership.owner_last_name }}
                </a>
                <span class="text-secondary ml-1">
                  Owner,
                  <ng-container *ngIf="membership.owner_is_member">
                    <span *ngIf="ownerMember && ownerMember.is_pending_addition">Pending</span>
                    Member
                  </ng-container>
                  <ng-container *ngIf="!membership.owner_is_member">Non-member</ng-container>
                </span>
                <span class="text-warning ml-1" *ngIf="ownerMember && ownerMember.is_individually_frozen">
                  Frozen
                </span>
                <span class="text-warning ml-1" *ngIf="ownerMember && ownerMember.is_pending_removal">
                  Will be removed on next bill date
                  (<a href="#"
                      [class.disabled]="loadingMembershipChange"
                      (click)="cancelRemoveMemberNextBillDate(membership, ownerMember); $event.preventDefault();">
                  Cancel</a>)
                </span>
                <span class="ml-1" *ngIf="ownerMember && ownerMember.is_pending_addition">
                  Will be added on next bill date
                  (<a href="#"
                      [class.disabled]="loadingMembershipChange"
                      (click)="cancelAddMemberNextBillDate(membership, ownerMember); $event.preventDefault();">Cancel</a>)
                </span>
                <i *ngIf="propExistsAndIsNonEmpty(membership.customer_add_ons[membership.owner_id.toString()])"
                   class="ml-1">
                  Add-ons:
                  <ng-container *ngFor="let addOn of membership.customer_add_ons[membership.owner_id.toString()]; let isLast = last;">
                    {{ addOn.name }}{{ isLast ? '' : ',' }}
                  </ng-container>
                </i>
              </span>
              <ng-container *ngIf="membership.owner_is_member">
                <span class="membership-name-secondary d-block" *ngIf="ownerMember.member_freeze_date">
                  - <span class="text-warning">Will freeze on {{ dateStringFromISO8601(ownerMember.member_freeze_date) }}</span>
                </span>
                <span class="membership-name-secondary d-block" *ngIf="ownerMember.member_unfreeze_date">
                  - <span class="text-warning">Will unfreeze on {{ dateStringFromISO8601(ownerMember.member_freeze_date) }}</span>
                </span>
              </ng-container>
            </ng-container>
            <ng-container *ngFor="let member of membership.customers_less_owner">
              <span class="membership-name-secondary d-block"
                    [class.font-italic]="member.is_pending_addition">
                <a routerLink="/customers/{{ member.id }}/memberships-and-passes">
                  {{ member.first_name }} {{ member.last_name }}
                </a>
                <span class="text-secondary ml-1">
                  <span *ngIf="member.is_pending_addition">Pending</span>
                  Member
                </span>
                <span class="text-warning ml-1" *ngIf="member.is_individually_frozen">
                  Frozen
                </span>
                <span class="text-warning ml-1" *ngIf="member.is_pending_removal">
                  Will be removed on next bill date
                  (<a href="#"
                      [class.disabled]="loadingMembershipChange"
                      (click)="cancelRemoveMemberNextBillDate(membership, member); $event.preventDefault();">Cancel</a>)
                </span>
                <span class="ml-1" *ngIf="member.is_pending_addition">
                  Will be added on next bill date
                  (<a href="#"
                      [class.disabled]="loadingMembershipChange"
                      (click)="cancelAddMemberNextBillDate(membership, member); $event.preventDefault();">Cancel</a>)
                </span>
                <i *ngIf="propExistsAndIsNonEmpty(membership.customer_add_ons[member.id.toString()])"
                   class="ml-1">
                  Add-ons:
                  <ng-container *ngFor="let addOn of membership.customer_add_ons[member.id.toString()]; let isLast = last;">
                    {{ addOn.name }}{{ isLast ? '' : ',' }}
                  </ng-container>
                </i>
              </span>
              <span class="membership-name-secondary d-block " *ngIf="member.member_freeze_date">
                - <span class="text-warning">Will freeze on {{ dateStringFromISO8601(member.member_freeze_date) }}</span>
              </span>
              <span class="membership-name-secondary d-block" *ngIf="member.member_unfreeze_date">
                - <span class="text-warning">Will unfreeze on {{ dateStringFromISO8601(member.member_unfreeze_date) }}</span>
              </span>
            </ng-container>
            <span class="membership-name-secondary d-block"
                  *ngFor="let membershipUnlinkedCustomer of membership.unlinked_customers">
              {{ membershipUnlinkedCustomer.first_name }} {{ membershipUnlinkedCustomer.last_name }}
              <ng-container *ngIf="loadingUnlinkedMembershipCustomer[membershipUnlinkedCustomer.id]">
                (<span class="text-muted">Loading...</span>)
              </ng-container>
              <ng-container *ngIf="!loadingUnlinkedMembershipCustomer[membershipUnlinkedCustomer.id]">
                (<a href="#" (click)="openLinkUnlinkedMembershipCustomerModal(membershipUnlinkedCustomer);$event.preventDefault();">Pending</a>)
              </ng-container>
              <span class="text-secondary ml-1">Member</span>
              <i *ngIf="propExistsAndIsNonEmpty(membership.customer_add_ons['u' + membershipUnlinkedCustomer.id.toString()])"
                 class="ml-1">
                Add-ons:
                <ng-container *ngFor="let addOn of membership.customer_add_ons['u' + membershipUnlinkedCustomer.id.toString()]; let isLast = last;">
                  {{ addOn.name }}{{ isLast ? '' : ',' }}
                </ng-container>
              </i>
            </span>
          </ng-container>
          <ng-container *ngIf="!shouldShowMembersList(membership)">
            <span class="membership-name-secondary d-block mt-3"
                  *ngIf="propExistsAndIsNonEmpty(membership.customer_add_ons[membership.all_customers[0].id.toString()])">
              Add-ons:
              <ng-container *ngFor="let addOn of membership.customer_add_ons[membership.all_customers[0].id.toString()]; let isLast = last;">
                {{ addOn.name }}{{ isLast ? '' : ',' }}
              </ng-container>
            </span>
          </ng-container>
          <ng-container *ngIf="objHasNonEmptyValues(membership.customer_add_ons_to_add)">
            <span class="membership-name-secondary d-block mt-3">
              The following add-ons will be added at the next bill date:
            </span>
            <ul class="membership-name-secondary mt-0">
              <ng-container *ngFor="let addOnCustomerId of Object.keys(membership.customer_add_ons_to_add)">
                <li *ngFor="let addOn of membership.customer_add_ons_to_add[addOnCustomerId]">
                  {{ addOn.name }}
                  <span *ngIf="!ownerIsOnlyMember(membership)">
                    ({{ getMemberNameById(membership, addOnCustomerId) }})
                  </span>
                </li>
              </ng-container>
            </ul>
          </ng-container>
          <ng-container *ngIf="objHasNonEmptyValues(membership.customer_add_ons_to_remove)">
            <span class="membership-name-secondary d-block mt-3">
              The following add-ons will be removed at the next bill date:
            </span>
            <ul class="membership-name-secondary mt-0">
              <ng-container *ngFor="let addOnCustomerId of Object.keys(membership.customer_add_ons_to_remove)">
                <li *ngFor="let addOn of membership.customer_add_ons_to_remove[addOnCustomerId]">
                  {{ addOn.name }}
                  <span *ngIf="!ownerIsOnlyMember(membership)">
                    ({{ getMemberNameById(membership, addOnCustomerId) }})
                  </span>
                </li>
              </ng-container>
            </ul>
          </ng-container>
          <ng-container *ngIf="membership.recurring_discount_amount && (parseFloat(membership.recurring_discount_amount) > 0)">
            <span class="membership-name-secondary d-block mt-3">
              {{ membership.recurring_discount_is_automatic ? 'Automatic' : 'Manual/Code' }}
              recurring discount:
              <ng-container *ngIf="membership.recurring_discount_type === MembershipDiscountType.currency">
                {{ orgConfig.formatCurrency(membership.recurring_discount_amount) }}
              </ng-container>
              <ng-container *ngIf="membership.recurring_discount_type === MembershipDiscountType.percentage">
                {{ membership.recurring_discount_amount }}%
              </ng-container>
              ({{ getRecurringDiscountNameString(membership) }})
            </span>
          </ng-container>
          <ng-container *ngIf="membership.one_off_discount_amount && (parseFloat(membership.one_off_discount_amount) > 0)">
            <span class="membership-name-secondary d-block mt-3">
              One-time discount:
              <ng-container *ngIf="membership.one_off_discount_type === MembershipDiscountType.currency">
                {{ orgConfig.formatCurrency(membership.one_off_discount_amount) }}
              </ng-container>
              <ng-container *ngIf="membership.one_off_discount_type === MembershipDiscountType.percentage">
                {{ membership.one_off_discount_amount }}%
              </ng-container>
               ({{ membership.one_off_discount_name }})
            </span>
          </ng-container>
        </td>
        <td class="membership-other-cell">
          {{ getMembershipPurchaseTypeDisplay(membership.purchase_type) }}
        </td>
        <td class="membership-other-cell">
          <ng-container *ngIf="membership.purchase_type === MembershipPurchaseType.recurring">
            {{ getMembershipIntervalDisplay(membership.interval) }}
          </ng-container>
          <ng-container *ngIf="membership.purchase_type === MembershipPurchaseType.prepaid">
            <ng-container *ngIf="membership.has_fixed_date_ranges">
              Fixed Date Range
            </ng-container>
            <ng-container *ngIf="!membership.has_fixed_date_ranges">
              {{ getMembershipDurationDisplay(membership.duration_years, membership.duration_months, membership.duration_days) }}
            </ng-container>
          </ng-container>
          <ng-container *ngIf="membership.purchase_type === MembershipPurchaseType.benefit">
            Duration of Event
          </ng-container>
        </td>
        <td>
          <button class="btn btn-secondary btn-sm float-right"
                  *ngIf="membership.is_pending_staff_approval"
                  (click)="openReviewMembershipPendingStaffApprovalModal(membership.id)">
            Review
          </button>
          <div class="d-flex justify-content-end" style="gap: 12px;"
               *ngIf="!membership.is_pending_staff_approval">
            <button class="btn btn-secondary btn-sm"
                    (click)="openDetailsModal(membership)">
              Details
            </button>
            <button class="btn btn-secondary btn-sm"
                    (click)="editMembership(membership)">
              Edit
            </button>
          </div>
        </td>
      </tr>
      <tr *ngIf="membershipsList.results.length === 0">
        <td colspan="99" class="text-muted">No memberships</td>
      </tr>
      </tbody>

      <tbody *ngIf="loadingMemberships">
      <tr>
        <td colspan="99" class="text-muted">Loading memberships...</td>
      </tr>
      </tbody>

    </table>
  </div>

  <app-pagination-row [(pageSize)]="pageSizeMemberships"
                      [(pageNum)]="membershipsPageNum"
                      [reloadSubject]="reloadMembershipsSubject"
                      [lastPageNum]="membershipsLastPageNum()"></app-pagination-row>

  <div class="rounded-table-wrapper rounded-table-tight table-responsive mb-2">
    <table class="table table-12px">

      <thead>
      <tr>
        <th scope="col" colspan="99" class="text-primary"
            style="font-size: 16px; padding-top: 8px; padding-bottom: 8px;">
          <button class="btn btn-sm btn-outline-primary float-right"
                  style="font-size: 12px; line-height: 12px;"
                  [disabled]="loadingCustomer"
                  [class.disabled]="loadingCustomer"
                  (click)="openPurchasePassModal()">
            Purchase Entry Pass
          </button>
          <button class="btn btn-sm btn-outline-primary float-right mr-2"
                  style="font-size: 12px; line-height: 12px;"
                  (click)="openAddEntryPassModal()">
            Add Manual Pass
          </button>
          <span style="position: relative; top: 4px;">Entry Passes</span>
        </th>
      </tr>
      <tr>
        <th scope="col">Pass Name</th>
        <th scope="col">Purchase Date</th>
        <th scope="col">Balance</th>
        <th scope="col">Expiration Date</th>
        <th scope="col"></th>
      </tr>
      </thead>

      <tbody *ngIf="!loadingEntryPasses">
      <tr *ngFor="let entryPass of entryPassesList.results"
          [class.font-italic]="entryPass.number_of_uses_remaining <= 0">
        <td class="membership-name-cell">
          {{ entryPass.name }}
          <!-- Only display the owner / linked if there are linked customers other than the owner,
               or if the entry pass is owned by an association -->
          <ng-container *ngIf="displayEntryPassLinkingDetails(entryPass)">
            <span class="membership-name-secondary d-block mt-2">
              <a routerLink="/customers/{{ entryPass.owner_id }}/memberships-and-passes">
                {{ entryPass.owner_first_name }} {{ entryPass.owner_last_name }}
              </a>
              <span class="text-secondary ml-1">
                Owner,
                <ng-container *ngIf="entryPass.owner_is_member">Linked</ng-container>
                <ng-container *ngIf="!entryPass.owner_is_member">Not Linked</ng-container>
              </span>
              <ng-container *ngIf="entryPass.owner_association_id !== null">
                <br>
                Purchased on behalf of
                <a [routerLink]="['/associations', entryPass.owner_association_id.toString()]" fragment="entry-passes">
                  {{ entryPass.owner_association_name }}
                </a>
              </ng-container>
            </span>
            <span class="membership-name-secondary d-block"
                  *ngFor="let passCustomer of entryPass.customers_less_owner">
              <a routerLink="/customers/{{ passCustomer.id }}/memberships-and-passes">
                {{ passCustomer.first_name }} {{ passCustomer.last_name }}
              </a>
              <span class="text-secondary ml-1">Linked</span>
            </span>
            <span class="membership-name-secondary d-block"
                  *ngFor="let passUnlinkedCustomer of entryPass.unlinked_customers">
              {{ passUnlinkedCustomer.first_name }} {{ passUnlinkedCustomer.last_name }}
              <ng-container *ngIf="loadingUnlinkedEntryPassCustomer[passUnlinkedCustomer.id]">
                (<span class="text-muted">Loading...</span>)
              </ng-container>
              <ng-container *ngIf="!loadingUnlinkedEntryPassCustomer[passUnlinkedCustomer.id]">
                (<a href="#" (click)="openLinkUnlinkedEntryPassCustomerModal(passUnlinkedCustomer);$event.preventDefault();">Pending</a>)
              </ng-container>
              <span class="text-secondary ml-1">Linked</span>
            </span>
          </ng-container>
        </td>
        <td>{{ dateStringFromISO8601(entryPass.created_date) }}</td>
        <td>
          <span *ngIf="entryPass.status === CustomerEntryPassStatus.removed"
                class="text-danger">
            Removed
          </span>
          <span>
            {{ entryPass.number_of_uses_remaining }} /
            {{ entryPass.number_of_uses_total }} Entries
          </span>
        </td>
        <td>
          <span *ngIf="!entryPass.expiration_date" class="text-muted">None</span>
          <span *ngIf="entryPass.expiration_date" [class.text-danger]="entryPass.status === CustomerEntryPassStatus.expired">
            <span *ngIf="entryPass.status === CustomerEntryPassStatus.expired">Expired</span>
            {{ dateStringFromISO8601(entryPass.expiration_date) }}
          </span>
        </td>
        <!-- Set width manually to prevent buttons from wrapping -->
        <td class="table-12px-button-cell" style="width: 108px;">
          <div class="dropdown">
            <button class="btn btn-sm btn-secondary table-12px-button float-right dropdown-toggle"
                    type="button" id="manageCEPDropdown{{ entryPass.id }}"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Manage
            </button>
            <div class="dropdown-menu" attr.aria-labelledby="manageCEPDropdown{{ entryPass.id }}">
              <a class="dropdown-item" href="#"
                 (click)="editEntryPass(entryPass);$event.preventDefault();">
                Edit
              </a>
              <a class="dropdown-item" href="#"
                 *ngIf="orgConfig.getOrganizationConfig().allow_entry_pass_linking"
                 (click)="linkEntryPass(entryPass);$event.preventDefault();">
                Link
              </a>
              <a class="dropdown-item" href="#"
                 *ngIf="(entryPass.owner_association_id === null) && (entryPass.status === CustomerEntryPassStatus.active)"
                 (click)="transferEntryPass(entryPass);$event.preventDefault();">
                Transfer
              </a>
            </div>
          </div>
        </td>
      </tr>
      <tr *ngIf="entryPassesList.results.length === 0">
        <td colspan="99" class="text-muted">No passes</td>
      </tr>
      </tbody>

      <tbody *ngIf="loadingEntryPasses">
      <tr>
        <td colspan="99" class="text-muted">Loading passes...</td>
      </tr>
      </tbody>

    </table>
  </div>

  <app-pagination-row [(pageSize)]="pageSizeEntryPasses"
                      [(pageNum)]="entryPassesPageNum"
                      [reloadSubject]="reloadEntryPassesSubject"
                      [lastPageNum]="entryPassesLastPageNum()"></app-pagination-row>

  <div class="rounded-table-wrapper rounded-table-tight table-responsive mb-2">
    <table class="table table-12px">

      <thead>
      <tr>
        <th scope="col" colspan="99" class="text-primary" style="font-size: 16px; height: 39px;">
          <span>Owned Guest Passes</span>
          <div class="float-right"
               style="position: relative; right: -8px; margin-top: -8px; margin-bottom: -8px;">
            <select class="custom-select custom-select-sm mr-1"
                    style="width: 160px;"
                    name="ownedGuestPassesStatus"
                    [(ngModel)]="ownedGuestPassesStatus"
                    (ngModelChange)="reloadOwnedGuestPassesSubject.next();">
              <option [ngValue]="null">Status: All</option>
              <option [ngValue]="GuestPassStatus.notYetAvailable">Status: Not Yet Available</option>
              <option [ngValue]="GuestPassStatus.available">Status: Available</option>
              <option [ngValue]="GuestPassStatus.assigned">Status: Assigned</option>
              <option [ngValue]="GuestPassStatus.used">Status: Used</option>
              <option [ngValue]="GuestPassStatus.expired">Status: Expired</option>
              <option [ngValue]="GuestPassStatus.removed">Status: Removed</option>
            </select>
            <button class="btn btn-outline-primary btn-sm"
                    (click)="openAddGuestPassModal()">
              Add Guest Pass
            </button>
          </div>
        </th>
      </tr>
      <tr>
        <th scope="col">Source</th>
        <th scope="col">Status</th>
        <th scope="col">Dates</th>
      </tr>
      </thead>

      <tbody *ngIf="!loadingOwnedGuestPasses">
      <tr *ngFor="let guestPass of ownedGuestPassesList.results">
        <td>
          {{ getGuestPassSourceText(guestPass) }}
          <ng-container *ngIf="(guestPass.status === GuestPassStatus.available) && guestPassIsUnusable(guestPass)">
            <span class="text-danger d-block">
              Temporarily unavailable: membership status is
              {{ getCustomerMembershipStatusDisplay(guestPass.granting_membership_status) }}
            </span>
          </ng-container>
        </td>
        <td>
          {{ getGuestPassStatusDisplay(guestPass.status) }}
          <ng-container *ngIf="guestPass.status === GuestPassStatus.available">
            ({{ getGuestPassEligibilityDisplay(guestPass.eligibility, orgConfig.getLapsedGuestPassWindowMonths()) }})
          </ng-container>
        </td>
        <td style="line-height: 14px">
          <span *ngIf="guestPass.available_starting_at_date" class="d-block">
            Available Starting: {{ dateStringFromISO8601(guestPass.available_starting_at_date) }}
          </span>
          <span *ngIf="guestPass.expires_at_date" class="d-block">
            Expires: End of {{ dateStringFromISO8601(guestPass.expires_at_date) }}
          </span>
          <span *ngIf="guestPass.used_at_date" class="d-block">
            Used: {{ dateStringFromISO8601(guestPass.used_at_date) }}
          </span>
          <span *ngIf="!guestPass.available_starting_at_date && !guestPass.expires_at_date && !guestPass.used_at_date"
                class="text-muted">
            N/A
          </span>
        </td>
        <td class="table-12px-button-cell">
          <button class="btn btn-sm btn-secondary table-12px-button float-right"
                  (click)="openManageGuestPassModal(guestPass)">
            Manage
          </button>
        </td>
      </tr>
      <tr *ngIf="ownedGuestPassesList.results.length === 0">
        <td colspan="99" class="text-muted">
          <ng-container *ngIf="ownedGuestPassesStatus">
            No "{{ getGuestPassStatusDisplay(ownedGuestPassesStatus) }}" guest passes
          </ng-container>
          <ng-container *ngIf="!ownedGuestPassesStatus">
            No guest passes
          </ng-container>
        </td>
      </tr>
      </tbody>

      <tbody *ngIf="loadingOwnedGuestPasses">
      <tr>
        <td colspan="99" class="text-muted">Loading guest passes...</td>
      </tr>
      </tbody>

    </table>
  </div>

  <app-pagination-row [(pageSize)]="pageSizeOwnedGuestPasses"
                      [(pageNum)]="ownedGuestPassesPageNum"
                      [reloadSubject]="reloadOwnedGuestPassesSubject"
                      [lastPageNum]="ownedGuestPassesLastPageNum()"></app-pagination-row>

  <div class="rounded-table-wrapper rounded-table-tight table-responsive mb-2">
    <table class="table table-12px">

      <thead>
      <tr>
        <th scope="col" colspan="99" class="text-primary" style="font-size: 16px; height: 39px;">
          <span style="position: relative; top: -2px;">Guest Pass Usage</span>
        </th>
      </tr>
      <tr>
        <th scope="col">Recipient</th>
        <th scope="col">New Customer (Y/N)</th>
        <th scope="col">Used Date</th>
      </tr>
      </thead>

      <tbody *ngIf="!loadingGuestPassUsages">
      <tr *ngFor="let guestPassUsage of guestPassUsagesList.results">
        <td>
          <a [routerLink]="'/customers/' + guestPassUsage.checked_in_customer_id.toString()">
            {{ guestPassUsage.checked_in_customer_first_name }} {{ guestPassUsage.checked_in_customer_last_name }}
          </a>
        </td>
        <td>{{ guestPassUsage.guest_was_new_customer ? 'Yes' : 'No' }}</td>
        <td>{{ dateStringFromISO8601(guestPassUsage.check_in_datetime) }}</td>
      </tr>
      <tr *ngIf="guestPassUsagesList.results.length === 0">
        <td colspan="99" class="text-muted">No guest pass usage</td>
      </tr>
      </tbody>

      <tbody *ngIf="loadingGuestPassUsages">
      <tr>
        <td colspan="99" class="text-muted">Loading guest pass usage...</td>
      </tr>
      </tbody>

    </table>
  </div>

  <app-pagination-row [(pageSize)]="pageSizeGuestPassUsages"
                      [(pageNum)]="guestPassUsagesPageNum"
                      [reloadSubject]="reloadGuestPassUsagesSubject"
                      [lastPageNum]="guestPassUsagesLastPageNum()"></app-pagination-row>

  <div class="rounded-table-wrapper rounded-table-tight table-responsive mb-2">
    <table class="table table-12px">

      <thead>
      <tr>
        <th scope="col" colspan="99" class="text-primary" style="font-size: 16px; height: 39px;">
          <span style="position: relative; top: -2px;">Shared Passes</span>
        </th>
      </tr>
      <tr>
        <th scope="col">Recipient</th>
        <th scope="col">Entry Method</th>
        <th scope="col">Used Date</th>
      </tr>
      </thead>

      <tbody *ngIf="!loadingSharedPasses">
      <tr *ngFor="let sharedPass of sharedPassesList.results">
        <td>
          <a [routerLink]="'/customers/' + sharedPass.shared_customer_id.toString()">
            {{ sharedPass.shared_customer_first_name }} {{ sharedPass.shared_customer_last_name }}
          </a>
        </td>
        <td>{{ sharedPass.entry_method_description }}</td>
        <td>{{ dateStringFromISO8601(sharedPass.check_in_datetime) }}</td>
      </tr>
      <tr *ngIf="sharedPassesList.results.length === 0">
        <td colspan="99" class="text-muted">No shared passes</td>
      </tr>
      </tbody>

      <tbody *ngIf="loadingSharedPasses">
      <tr>
        <td colspan="99" class="text-muted">Loading shared passes...</td>
      </tr>
      </tbody>

    </table>
  </div>

  <app-pagination-row [(pageSize)]="pageSizeSharedPasses"
                      [(pageNum)]="sharedPassesPageNum"
                      [reloadSubject]="reloadSharedPassesSubject"
                      [lastPageNum]="sharedPassesLastPageNum()"></app-pagination-row>

</div>
